import school from '../config/schools';
import { auth } from '../firebase';

const FUNCTIONS_BASE_BY_SCHOOL = {
  sfs: 'https://us-central1-espanol-con-vic.cloudfunctions.net',
  efs: 'https://us-central1-english-fluency-school.cloudfunctions.net',
};

export const EMAIL_FUNCTIONS_BASE =
  FUNCTIONS_BASE_BY_SCHOOL[school.id] || FUNCTIONS_BASE_BY_SCHOOL.sfs;

// Headers para llamar a una función de email: JSON + la sesión de quien llama
// (`Authorization: Bearer <ID token>`), para que la función pueda verificar
// quién envía. Seguridad Fase 1 — admin-mentor-integracion.md, sección G.
// Sin sesión (o si el token falla) se manda solo el JSON: la función decide.
export async function emailRequestHeaders() {
  const headers = { 'Content-Type': 'application/json' };
  try {
    const token = await auth?.currentUser?.getIdToken();
    if (token) headers.Authorization = `Bearer ${token}`;
  } catch (err) {
    console.warn('[emailFunctions] No se pudo obtener el token de sesión:', err);
  }
  return headers;
}
